import { render, staticRenderFns } from "./anidb-release-group-ui.vue?vue&type=template&id=5721f056&scoped=true&"
import script from "./anidb-release-group-ui.vue?vue&type=script&lang=js&"
export * from "./anidb-release-group-ui.vue?vue&type=script&lang=js&"
import style0 from "./anidb-release-group-ui.vue?vue&type=style&index=0&id=5721f056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721f056",
  null
  
)

export default component.exports